import meta from './meta';

export default {
  pricePrefix: '{0} р.',
  pricePostfix: '{0} р.',
  ...meta,
};
